import React,{useState,}from 'react'
import { Modal,Form,Input, Button,message, DatePicker,} from 'antd';
import { useBnsGuangGaoFaBuAddMutation } from '../../store/ReactWebSiteApi';
import MyEditor from '../../cpn/MyEditor';
import dayjs from 'dayjs';
import GetUser from '../../cpn/GetUser';
import MediaForm from '../../promote/media/MediaForm';
import GetUserDept from '../../cpn/GetUserDept';
import PackageForm from '../../promote/package/PackageForm';
function PublishAdd() {    
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);   
    const [add]  = useBnsGuangGaoFaBuAddMutation()
    const [info,setInfo] = useState({
        bggfb_content:'',
    });
    return (
            <>
                <Button
                    onClick={() => {setOpen(true)}}
                    type='primary'
                >新增</Button>
                <Modal
                    width={1000}
                    open={open}
                    title='新增广告发布'
                    okText="提交"
                    cancelText="取消"
                    onCancel={() => {setOpen(false);}}
                    onOk={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                form.resetFields();  
                                add({
                                    "bggfb_bg_id" : info.bggfb_bg_id,
                                    "bggfb_bg_name" : info.bggfb_bg_name,
                                    "bggfb_cid" : localStorage.getItem('eu_id'),
                                    "bggfb_cname" : localStorage.getItem('eu_name'),
                                    "bggfb_dept_id" : info.bggfb_dept_id,
                                    "bggfb_dept_name" : info.bggfb_dept_name,
                                    "bggfb_e_id" : localStorage.getItem('e_id'),
                                    "bggfb_fuzhuren_id" : info.bggfb_fuzhuren_id,
                                    "bggfb_fuzhuren_name" : info.bggfb_fuzhuren_name,
                                    "bggfb_jihuariqi" : info.bggfb_jihuariqi,
                                    "bggfb_meijie_id" : info.bggfb_meijie_id,
                                    "bggfb_meijie_name" : info.bggfb_meijie_name,
                                    "bggfb_name" : info.bggfb_name,
                                    "bggfb_content" : info.bggfb_content,
                                    "bggfb_bbz_id" : info.bggfb_bbz_id,
                                    "bggfb_bbz_name" : info.bggfb_bbz_name,
                                }).then((res) => {
                                    if (res.data.Status === 'success') {
                                        message.info('新增成功！');
                                        setOpen(false);
                                    }
                                    if (res.data.Status === "fail") {
                                        message.error('新增失败！'+res.data.Message)
                                    }
                                })                        
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });                    
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}
                    >
                        <GetUserDept 
                            label='部门'
                            required
                            wrapperCol={{span:10}} 
                            getUserDept={(e,f) => {
                                setInfo(prevState=>({...prevState,bggfb_dept_id:e,bggfb_dept_name:f}))
                            }}
                        />
                        <MediaForm
                            wrapperCol={{span:10}}
                            required
                            onChange={(e,f) => {
                                setInfo(prevState=>({...prevState,bggfb_meijie_id:e,bggfb_meijie_name:f.label}))
                            }}
                        />
                        <PackageForm
                            onChange={(e,f) => {
                                setInfo(prevState=>({...prevState,bggfb_bg_id:e,bggfb_bg_name:f.label}))
                            }}
                            onChangePackage={(e,f) => {
                                setInfo(prevState=>({...prevState,bggfb_bbz_id:e,bggfb_bbz_name:f.label}))
                            }}
                        />
                        <GetUser
                            label='负责人'
                            required
                            wrapperCol={{span:10}} 
                            getUser={(e,f) => {
                                
                                setInfo(prevState=>({...prevState,bggfb_fuzhuren_id:e,bggfb_fuzhuren_name:f}))
                            }}
                        />
                        <Form.Item
                            wrapperCol={{span:20}} 
                            style={{marginBottom:"0"}}
                            label='计划日期'required
                        >
                            <Form.Item name="date">
                                <DatePicker
                                     onChange={(e) => {setInfo(prevState=>({...prevState,bggfb_jihuariqi:dayjs(e).format('YYYY-MM-DD')}))}} 
                                />
                            </Form.Item>
                        </Form.Item>
                        <Form.Item name="name" label='名称' wrapperCol={{span:20}} required>
                            <Input 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bggfb_name:e.target.value}))}}
                            />
                        </Form.Item> 
                        <Form.Item name="remark" label='备注' wrapperCol={{span:20}}>
                            <MyEditor 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bggfb_content:e}))}}
                            />
                        </Form.Item> 
                    </Form>
                </Modal>
            </>
        )
}

export default PublishAdd